import MainPage from 'components/mainpage/MainPage';
import About from 'components/about/About';
import Portfolio from 'components/portfolio/Portfolio';
import Item from 'components/portfolio/Item';
import Services from 'components/services/Services';
import Wedding from 'components/services/Wedding';
import Events from 'components/services/Events';
import Floristic from 'components/services/Floristic';
import Contacts from 'components/contacts/Contacts';

export default [
  {
    path: '/',
    name: 'main_page',
    component: MainPage,
  },
  {
    path: '/about/',
    name: 'about',
    component: About,
  },
  {
    path: '/portfolio/',
    name: 'portfolio',
    component: Portfolio,
  },
  {
    path: '/portfolio/:id/',
    name: 'portfolio_page',
    component: Item,
  },
  {
    path: '/services/',
    name: 'services',
    component: Services,
  },
  {
    path: '/services/wedding/',
    name: 'services_wedding',
    component: Wedding,
  },
  {
    path: '/services/events/',
    name: 'services_events',
    component: Events,
  },
  {
    path: '/services/floristic',
    name: 'services_floristic',
    component: Floristic,
  },
  {
    path: '/contacts/',
    name: 'contacts',
    component: Contacts,
  },
];



// WEBPACK FOOTER //
// ./src/routes.js